// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._1ul9p3fh{min-width:15pc}\n._2lx21bp4{flex-direction:column}\n._4t3i1osq{height:100%}\n._bfhkxkvu{background-color:var(--_4p0s90)}\n._kqswh2mm{position:relative}\n._syaz1425{color:var(--_13a5t4u)}", ""]);
// Exports
module.exports = exports;
